/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReservationRequestPolicy
 */
export interface UpdateReservationRequestPolicy {
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequestPolicy
     */
    type: UpdateReservationRequestPolicyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateReservationRequestPolicy
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequestPolicy
     */
    method?: UpdateReservationRequestPolicyMethodEnum;
}


/**
 * @export
 */
export const UpdateReservationRequestPolicyTypeEnum = {
    Card: 'CARD',
    Deposit: 'DEPOSIT',
    None: 'NONE'
} as const;
export type UpdateReservationRequestPolicyTypeEnum = typeof UpdateReservationRequestPolicyTypeEnum[keyof typeof UpdateReservationRequestPolicyTypeEnum];

/**
 * @export
 */
export const UpdateReservationRequestPolicyMethodEnum = {
    All: 'ALL',
    ByPerson: 'BY-PERSON',
    LargeGroups: 'LARGE-GROUPS'
} as const;
export type UpdateReservationRequestPolicyMethodEnum = typeof UpdateReservationRequestPolicyMethodEnum[keyof typeof UpdateReservationRequestPolicyMethodEnum];


/**
 * Check if a given object implements the UpdateReservationRequestPolicy interface.
 */
export function instanceOfUpdateReservationRequestPolicy(value: object): value is UpdateReservationRequestPolicy {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateReservationRequestPolicyFromJSON(json: any): UpdateReservationRequestPolicy {
    return UpdateReservationRequestPolicyFromJSONTyped(json, false);
}

export function UpdateReservationRequestPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReservationRequestPolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'method': json['method'] == null ? undefined : json['method'],
    };
}

export function UpdateReservationRequestPolicyToJSON(json: any): UpdateReservationRequestPolicy {
    return UpdateReservationRequestPolicyToJSONTyped(json, false);
}

export function UpdateReservationRequestPolicyToJSONTyped(value?: UpdateReservationRequestPolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'amount': value['amount'],
        'method': value['method'],
    };
}

